import mime from 'mime';
import { checkIfFileAndHasExtensionFromFileName, extractFileExtensionFromFileName, extractRecognizedMultipartFileExtensionFromFileName, } from '#services';
export const getRecognizedFileExtensionFromFileName = (fileName) => {
    if (!checkIfFileAndHasExtensionFromFileName(fileName) &&
        !fileName.startsWith('.')) {
        return null;
    }
    const multipartExtension = extractRecognizedMultipartFileExtensionFromFileName(fileName);
    // We have recognized a multipart extension
    if (multipartExtension.length !== 0) {
        return multipartExtension;
    }
    const extension = extractFileExtensionFromFileName(fileName);
    if (extension.length !== 0 && mime.getType(extension) !== null) {
        return extension;
    }
    return null;
};
